import { API } from './resources'

export default {
  get: (platform, page) => {
    return API.get('/home', { params: { platform: platform, page: page } })
  },
  getExplorePage: (path) => {
    return API.get(`/home/${path}/explore`)
  },
  getYSC: () => {
    return API.get('/home/ysc')
  },
  getYSCSTEMExpo: (language) => {
    return API.get('/home/yscstemexpo', { params: { language: language } })
  },
  getCollegeHall: () => {
    return API.get('/home/collegehall')
  },
  getCareerHall: () => {
    return API.get('/home/careerhall')
  },
  getSTEMExperientialHall: () => {
    return API.get('/home/stemexperientialhall')
  },
  getAJAS: () => {
    return API.get('/home/ajas')
  },
  getISEF: () => {
    return API.get('/home/isef')
  },
  getForFair: (fair) => {
    return API.get(`/home/fairs/${fair}`)
  }
}
